import { render, staticRenderFns } from "./EditCountryPage.vue?vue&type=template&id=d5bf0df4&scoped=true"
import script from "./EditCountryPage.vue?vue&type=script&lang=js"
export * from "./EditCountryPage.vue?vue&type=script&lang=js"
import style0 from "./EditCountryPage.vue?vue&type=style&index=0&id=d5bf0df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bf0df4",
  null
  
)

export default component.exports